// Las etiquetas del embudo en el GTM de producción solo disparan si la variable
// `didomiVendorsConsent` incluye a Google Analytics, y esa variable no existe
// hasta que Didomi empuja `didomi-consent`. GTM evalúa cada evento una sola vez,
// con lo que haya en ese instante: un evento empujado antes no dispara nunca.
// Los que se emiten al cargar la página (`signup_view`, `welcome_step_viewed`,
// los CTAs visibles sin scroll) le ganaban la carrera a Didomi por unas decenas
// de milisegundos y se perdían casi todos.
//
// Por eso, en las páginas con Didomi (`esperaAlConsentimiento`, que publica el
// servidor), el push espera a `didomiOnReady`, que corre después de
// `didomi-consent`. No se espera a la mera existencia de `didomiOnReady`: el
// snippet de HubSpot también lo crea, y en una página sin Didomi el evento se
// quedaría esperando para siempre.
//
// Lo comparten el embudo de onboarding (`analitica_del_embudo.js`) y las
// conversiones de negocio (`conversiones_analiticas.js`, planes 35–38 de la
// auditoría de analítica de oct-2026).
export function cuandoGtmConozcaElConsentimiento (empuja, esperaAlConsentimiento) {
  const yaLoConoce = (window.dataLayer || []).some((item) => item && item.event === 'didomi-consent')
  if (yaLoConoce || !esperaAlConsentimiento) return empuja()

  window.didomiOnReady = window.didomiOnReady || []
  window.didomiOnReady.push(empuja)
}
